import { PencilSquareIcon, TrashIcon } from "@heroicons/react/16/solid";
import { ChatSessionDTO } from "@tumtutor/shared/dto";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { openModal } from "../../../components/modal";

interface ChatSessionCardProps {
  session: ChatSessionDTO;
  setSearchParams: (
    params: { sessionId: string },
    options?: { replace?: boolean },
  ) => void;
  currentChatSession?: ChatSessionDTO;
  setChatSessionToDelete: Dispatch<SetStateAction<string>>;
  patchChatSession: ({ sessionId, courseId, body: { name } }) => void;
  deleteChatSessionModalId: string;
}

export function ChatSessionCard({
  session,
  setSearchParams,
  currentChatSession,
  setChatSessionToDelete,
  patchChatSession,
  deleteChatSessionModalId,
}: ChatSessionCardProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [newSessionName, setNewSessionName] = useState(session.name);
  const { courseId } = useParams();
  const { t } = useTranslation("chatPage");

  return (
    <li
      key={session.id}
      onClick={() => {
        setSearchParams({ sessionId: session.id }, { replace: true });
        const drawerElement = document.getElementById(
          "session-drawer",
        ) as HTMLInputElement | null;
        if (drawerElement) {
          drawerElement.checked = false;
        }
      }}
      onKeyUp={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          setSearchParams({ sessionId: session.id }, { replace: true });
          const drawerElement = document.getElementById(
            "session-drawer",
          ) as HTMLInputElement | null;
          if (drawerElement) {
            drawerElement.checked = false;
          }
        }
      }}
      className={`cursor-pointer ${
        currentChatSession?.id === session.id ? "rounded-lg bg-base-300" : ""
      }`}
    >
      <div className="flex justify-between">
        {isEditing ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              patchChatSession({
                sessionId: session.id,
                courseId: courseId,
                body: {
                  name: newSessionName,
                },
              });
              setIsEditing(false);
            }}
          >
            <input
              type="text"
              value={newSessionName || t("chatSession.defaultNameSession")}
              onChange={(e) => {
                setNewSessionName(e.target.value);
              }}
              onClick={(e) => e.stopPropagation()}
              minLength={1}
              maxLength={30}
              required
              className="input input-xs input-bordered"
            />
          </form>
        ) : (
          <p>
            {session.name && session.name.length > 30
              ? `${session.name.substring(0, 30)}...`
              : session.name || t("chatSession.defaultNameSession")}
          </p>
        )}
        {!isEditing && (
          <div className="flex items-center">
            <PencilSquareIcon
              className={"mx-2 h-5 w-5 cursor-pointer"}
              onClick={(e) => {
                e.stopPropagation();
                setIsEditing(true);
              }}
            />
            <TrashIcon
              className="h-5 w-5"
              onClick={async (e) => {
                e.stopPropagation();
                openModal(deleteChatSessionModalId);
                setChatSessionToDelete(session.id);
              }}
            />
          </div>
        )}
      </div>
    </li>
  );
}
